import { type ReactElement, useCallback } from 'react'
import { Calendar } from 'react-date-range'
import { useSnapshot } from 'valtio'
import cn from 'classnames'
import { executeRetrieveRecurringPaymentsSearch } from '../../../../../../../../shared/apiUtils/executeRetrieveRecurringPaymentsSearch'
import { proxyGlobalAuth } from '../../../../../../../../shared/proxies/proxyGlobalAuth'

interface ExpandedDatePickerProps {
  closeExpanded: () => void
  date: Date | null
  onClear: () => void
  onChange: (arg0: Date) => void
}

export function ExpandedDatePicker ({ closeExpanded, date, onClear, onChange }: ExpandedDatePickerProps): ReactElement {
  const onApply = useCallback(() => {
    closeExpanded()
    void executeRetrieveRecurringPaymentsSearch({ displayLoader: false })
  }, [closeExpanded])

  const { siteTheme: { datepickerFilterColors } } = useSnapshot(proxyGlobalAuth)

  return (
    <div
      className="absolute top-12 right-0 rounded border border-gray-200 animate__animated animate__fadeIn bg-white z-10"
      style={{ animationDuration: '100ms', width: '23rem' }}
    >
      <div className="px-4 pb-3 bg-white">
        <Calendar
          color={datepickerFilterColors.selectedColorClasses}
          date={date ?? new Date()}
          onChange={onChange}
        />
      </div>

      <div className={cn(datepickerFilterColors.buttonBackgroundClasses, 'h-12 w-full flex justify-between py-2 px-12')}>
        <button
          className={cn(datepickerFilterColors.clearButtonClasses, 'text-white')}
          onClick={onClear}
        >
          Clear
        </button>
        <button
          className={`${datepickerFilterColors.applyButtonClasses} font-semibold bg-white rounded px-5`}
          onClick={onApply}
        >
          Apply
        </button>
      </div>
    </div>
  )
}
